import TYPES from "../types";

const initialState = {
  userdata: '',
  modelsdata: '',
  suppliersdata: '',
  phonesdata: '',
  allphonesdata: '',
  allclientsdata: '',
  allexpensesdata: '',
  reportsdata: '',
  staffusersdata: '',
  allstoresdata: [],
  allstoresloading: false,
  allstoreserror: '',
  activitiesdata: '',
  dashboardstatdata: '',
  stockdata: '',
  generaldashboardstatdata: '',
  generalSalesdata: '',
  generalclientsdata: '',
  generalreportsdata: '',
};

export const UserReducer = (state = initialState, action: { type: any; payload: { data: any; }; }) => {
  switch (action.type) {
    case TYPES.USER_DATA:
      return { ...state, userdata: action.payload };
    case TYPES.MODELS_DATA:
      return { ...state, modelsdata: action.payload };
    case TYPES.SUPPLIERS_DATA:
      return { ...state, suppliersdata: action.payload };
    case TYPES.PHONES_DATA:
      return { ...state, phonesdata: action.payload };
    case TYPES.ALL_PHONES_DATA:
      return { ...state, allphonesdata: action.payload };
    case TYPES.UPDATE_PHONE:
      return {
        ...state,
        allphonesdata: {
          // @ts-ignore
          ...state.allphonesdata,
          // @ts-ignore
          data: state.allphonesdata.data.map((p: any) =>
            // @ts-ignore
            p._id === action.payload._id ? action.payload : p
          ),
        },
      }
    case TYPES.ALL_CLIENTS_DATA:
      return { ...state, allclientsdata: action.payload };
    case TYPES.ALL_EXPENSES_DATA:
      return { ...state, allexpensesdata: action.payload };
    case TYPES.REPORTS_DATA:
      return { ...state, reportsdata: action.payload };
    case TYPES.STAFF_USERS_DATA:
      return { ...state, staffusersdata: action.payload };
    case TYPES.ALL_STORES_DATA:
      return { ...state, allstoresdata: action.payload, allstoresloading: false, allstoreserror: '' };
    case TYPES.ALL_STORES_LOADING:
      return { ...state, allstoresdata: [], allstoresloading: true, allstoreserror: '' };
    case TYPES.ALL_STORES_ERROR:
      return { ...state, allstoresloading: false, allstoreserror: action.payload };
    case TYPES.LOGS_ACTIVITIES_DATA:
      return { ...state, activitiesdata: action.payload };
    case TYPES.DASHBOARD_STAT_DATA:
      return { ...state, dashboardstatdata: action.payload };
    case TYPES.STOCK_SUMMARY_DATA:
      return { ...state, stockdata: action.payload };
    case TYPES.GENERAL_DASHBOARD_STAT_DATA:
      return { ...state, generaldashboardstatdata: action.payload };
    case TYPES.ALL_GENERAL_SALES_DATA:
      return { ...state, generalSalesdata: action.payload };
    case TYPES.ALL_GENERAL_CLIENTS_DATA:
      return { ...state, generalclientsdata: action.payload };
    case TYPES.GENERAL_REPORTS_DATA:
      return { ...state, generalreportsdata: action.payload };
    default:
      return state;
  }
};
